import { createContext } from 'react';
import { IToolbarItemProps } from './variants';

interface IToolbarContextProps {
    upsert(itemInfo: IToolbarItemProps): void;
    remove(id: string): void;
}

export const ToolbarContext = createContext<IToolbarContextProps>({
    upsert() { /** Default upsert method */ },
    remove() { /** Default remove method */ }
});
